import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd-v5';
import TemplatedTextSalesTriggers from '../../TemplatedTextSalesTriggers';
import { setTriggerActionObj } from '../../../../reducers/salesTriggers';
import { notificationError } from '../../../../core/actions';

const ReminderMessageTriggerTemplate = props => {
  const history = useHistory();
  const hasMessageText = Boolean(props.salesTriggers.actionMsgText?.trim());

  const handleSave = () => {
    if (!props.salesTriggers.actionMsgText?.trim()) {
      notificationError('Template Message Required');
      return;
    }
    props.onclickSave();
  };

  useEffect(() => {
    // if (props.merchantId) {
    //     if (
    //         !props.autoRemMsgs.msgTempId &&
    //         window.location.href.includes("edit-message-template")
    //     ) {
    //         setRemTempAddEdit("Edit");
    //         (async () => {
    //             const data = await getList(
    //                 props.type,
    //                 props.merchantId,
    //                 "messageTemplates",
    //                 props.match.params.reminderId,
    //                 `?templateId=${props.match.params.templateId}`
    //             );
    //             if (data && data.length > 0) {
    //                 setRemTempMsgText(data[0].msg);
    //                 setRemTempMsgId(data[0].id);
    //             } else {
    //                 history.push(props.cancelRoute);
    //                 console.error("Failed to get message template");
    //             }
    //         })();
    //     }
    // }
  }, [props.merchantId]);

  return (
    <div className="align-left">
      <div
        style={{
          maxWidth: '500px',
          justifyContent: 'flex-end',
          display: 'flex',
        }}
      />

      <span style={{ display: 'block' }}>Message Body</span>
      <TemplatedTextSalesTriggers
        val={props.salesTriggers.actionMsgText}
        changeHandler={val => {
          setTriggerActionObj({ actionMsgText: val });
        }}
      />

      <div className="flex-col-center m-top-37 m-btm-20">
        <div className="mq-w-100-vw">
          <Button size="large" className="m-right-8" onClick={props.cancelRoute}>
            Cancel
          </Button>
          <Button type="primary" size="large" className="m-left-8" onClick={handleSave} disabled={!hasMessageText}>
            Save
          </Button>
        </div>
      </div>
      {/* {redirect ? <Redirect to={props.cancelRoute} /> : null} */}
    </div>
  );
};
const mapStateToProps = state => ({
  ...state.auth,
  salesTriggers: state.salesTriggers,
});
export default connect(mapStateToProps, {})(ReminderMessageTriggerTemplate);
